import { useEffect } from 'react'

export interface Shortcut {
  key: string      // e.g. 'M', 'S', 'B'
  shift?: boolean
  description: string
  handler: () => void
}

export const APP_SHORTCUTS: Omit<Shortcut, 'handler'>[] = [
  { key: 'B', shift: true, description: 'Toggle sidebar' },
  { key: 'M', shift: true, description: 'Focus navigation menu' },
  { key: 'S', shift: true, description: 'Focus search field' },
  { key: 'K', shift: true, description: 'Show keyboard shortcuts' },
  { key: '?', shift: true, description: 'Show keyboard shortcuts' },
]

export function useKeyboardShortcuts(shortcuts: Shortcut[]) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't fire inside inputs/textareas
      const tag = (e.target as HTMLElement)?.tagName?.toLowerCase()
      if (tag === 'input' || tag === 'textarea' || tag === 'select') return

      for (const shortcut of shortcuts) {
        const shiftMatch = shortcut.shift ? e.shiftKey : !e.shiftKey
        if (shiftMatch && e.key.toUpperCase() === shortcut.key.toUpperCase()) {
          e.preventDefault()
          shortcut.handler()
          break
        }
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [shortcuts])
}
